// React Thirty Party Library

// Constants Library
import { ROOT_CONSTANT } from "../../../../constants";

const { 
    SUB,
    MAIN
} = ROOT_CONSTANT.IMG.ICON.LOGO;

const Logo = ({
    collapsed
}) => {

    return (
        <div style={{ display: 'flex', justifyContent: 'center', margin: '4.5vh 0' }}>
            <img
                src={collapsed ? SUB : MAIN}
                alt="Bolt Logo"
                style={{
                    width: collapsed ? '2em' : '10em',
                }}
            />
        </div>
    );
};
export default Logo;
